var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.973 13.953 11.975 11m0 0c-.001-.926.672-1.638 1.502-1.639.831 0 1.505.712 1.505 1.639l.002 1m-3.01-1 .018-4.101c0-.927-.673-1.679-1.504-1.679h-.002c-.83.001-1.502.753-1.501 1.679.007 6.556.006 8.113-.002 8.111-1.378 0-2.421-1.953-4.23-1.953-1.81 0-2.113 1.073-1.39 2.023.482.633 5.62 6.92 5.62 6.92H17a4 4 0 0 0 4-4v-4.82c0-.927-.674-1.679-1.505-1.679h-.001c-.83.001-1.502.753-1.501 1.679M14.983 12v1.953m0-1.953c0-.926.672-1.678 1.502-1.679h.001c.831 0 1.505.752 1.505 1.679l.002 1.179m0 0-.002.774M15.416 6.25h-1.5m-7 0H5.12m9.009-3.712L12.89 3.775M6.704 2.538l1.238 1.237M10.416 1v1.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand4);
export default __webpack_public_path__ + "static/media/hand4.2a5a9cc82aeb3f7413c829c620d80af7.svg";
export { ForwardRef as ReactComponent };